import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/shared/widgets/dialog';

interface ProductVideoModalProps {
  open: boolean;
  onClose: () => void;
  videoUrl: string;
  videoPosterUrl?: string;
  productName: string;
  productPageUrl?: string;
}

export default function ProductVideoModal({
  open,
  onClose,
  videoUrl,
  videoPosterUrl,
  productName,
  productPageUrl,
}: ProductVideoModalProps) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent showCloseButton className="max-w-sm overflow-hidden p-0 gap-0">
        <DialogHeader className="p-4">
          <DialogTitle className="line-clamp-1 text-sm font-medium">
            {productName}
          </DialogTitle>
        </DialogHeader>
        {/* Wrap video + overlay button; group enables hover detection */}
        <div className="group">
          {/* key forces video element to remount when URL changes */}
          <video
            key={videoUrl}
            controls
            autoPlay
            playsInline
            poster={videoPosterUrl}
            className="block w-full"
            style={{ display: 'block' }}
          >
            <source src={videoUrl} type="video/mp4" />
          </video>
          {productPageUrl && (
            <div className="grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-[grid-template-rows] duration-300">
              <div className="overflow-hidden">
                <a
                  href={productPageUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block bg-[#E84C3D] py-3 text-center text-sm font-bold uppercase tracking-widest text-white hover:bg-[#c73d30]"
                >
                  View Details
                </a>
              </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
